/**
 * @author Mukesh kumar bairwa <mukesh.bairwa@314ecorp.com>
 * @description Fields for QueryBuilder
 */

import _ from 'lodash';
import { FieldOrGroup, Fields } from '@react-awesome-query-builder/antd';
import { useMemo } from 'react';

import { CORE_CONFIG, IFieldsData } from '../config/entity.config';

class RAQBFields {
	definitions = [];
	config: AnyRecord = {};

	constructor(definitions: IFieldsData[], entityConfig: AnyRecord) {
		this.definitions = definitions;
		this.config = entityConfig;
	}

	createFieldProperties = (definition: IFieldsData): FieldOrGroup => {
		return CORE_CONFIG?.[definition.ui_field_type]?.getField?.(definition);
	};

	addField = (source: Fields, key: string | string[], value: AnyType): void => {
		if (value) {
			_.setWith(source, _.castArray(key), value, Object);
		}
	};

	createFieldsRecursively = (fields: Fields, unSortedDefinitions: AnyType): Fields => {
		const definitions = _.sortBy(unSortedDefinitions, (item) => _.toLower(item?.display_name || ''));

		_.forEach(definitions, (definition: IFieldsData) => {
			const fieldProperties = this.createFieldProperties(definition);
			this.addField(fields, [definition.field], {
				...fieldProperties,
				label2: definition.display_name,
				...(definition?.operators && { operators: definition.operators }),
			});
		});

		return fields;
	};

	create = (definitions: IFieldsData[]): Fields => {
		return this.createFieldsRecursively({}, definitions);
	};
}

const useFields = (definitions: IFieldsData[]): Fields => {
	return useMemo(() => {
		const instance = new RAQBFields(definitions, CORE_CONFIG);
		return instance.create(definitions);
	}, [definitions]);
};

export { RAQBFields };
export default useFields;
